module.exports = __webpack_public_path__ + "img/users-icon.f96bfd7a.svg";